import React from "react";
import Context from "../../../../context";

import {
  CustomLeaflet,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../components";
import values from "../../../../values";
import "./index.scss";
import { useTranslation } from "react-i18next";

const SchoolInformation = () => {
  const { showModal, setShowModal, selectedSchool } = React.useContext(
    Context.SchoolScreen
  );
  // eslint-disable-next-line array-callback-return
  selectedSchool?.grade?.map((item: any) => {
    values.dropdownItems.GRADE.find((item1: any) => item1._id === item.grade);
  });

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"40vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedSchool?.avatar}
            name={
              selectedSchool?.firstName
                ? selectedSchool?.firstName
                : selectedSchool?.name
            }
            lastName={selectedSchool?.lastName ? selectedSchool?.lastName : ""}
            phoneNumber={
              selectedSchool?.phoneNumber
                ? selectedSchool?.phoneNumber
                : selectedSchool?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedSchool?.fullName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("schoolManager")} :</label>
                <p>{selectedSchool?.fullName}</p>
              </CustomView.Column>
            )}

            {selectedSchool?.phoneNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("phoneNumber")} :</label>
                <p>{selectedSchool?.phoneNumber}</p>
              </CustomView.Column>
            )}

            {selectedSchool?.province && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>{selectedSchool?.province?.Name}</p>
              </CustomView.Column>
            )}

            {selectedSchool?.city && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>{selectedSchool?.city?.Name}</p>
              </CustomView.Column>
            )}
            {selectedSchool?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={10}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>{selectedSchool?.address}</p>
              </CustomView.Column>
            )}
            <div className="timing-container">
              <h6>
                <span>{t("schoolTiming")}</span>
              </h6>
              {selectedSchool?.grade?.map((item: any) => {
                const thisGrade = values.dropdownItems.GRADE.find(
                  (item1: any) => item1._id === item.grade
                );
                return (
                  <CustomView.Row className="timing">
                    <CustomView.Column
                      className="form-label"
                      medium={5}
                      small={12}
                      large={2}
                    >
                      {thisGrade?.name}
                      {":"}
                    </CustomView.Column>
                    <CustomView.Column
                      className="form-week-day"
                      medium={5}
                      small={12}
                      large={4}
                    >
                      <label className="form-label">{t("enterTime")}:</label>
                      <div className="form-value">
                        {new Date(item?.entranceTime).toLocaleString("en-US", {
                          timeZone: "Africa/Abidjan",
                          hour12: false,
                          hour: "numeric",
                          minute: "numeric",
                        })}
                      </div>
                    </CustomView.Column>
                    <CustomView.Column
                      className="form-week-day"
                      medium={5}
                      small={12}
                      large={4}
                    >
                      <label className="form-label">{t("leaveTime")}:</label>
                      <div className="form-value">
                        {new Date(item?.departTime).toLocaleString("en-US", {
                          timeZone: "Africa/Abidjan",
                          hour12: false,
                          hour: "numeric",
                          minute: "numeric",
                        })}
                      </div>
                    </CustomView.Column>
                  </CustomView.Row>
                );
              })}
            </div>

            {/* {selectedSchool?.grade && (
              <CustomView.Column medium={5} small={12} large={4} className="form-values form-column">
                <label className="form-label">مقطع :</label>
                <p>{selectedSchool?.grade}</p>
              </CustomView.Column>
            )} */}
          </CustomView.Row>

          {selectedSchool?.lat && selectedSchool?.long && (
            <CustomView.Row className="center-row-content">
              <CustomLeaflet
                defaultLat={selectedSchool.lat}
                defaultLng={selectedSchool.long}
              />
            </CustomView.Row>
          )}
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default SchoolInformation;
